export default class PositionActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_POSITION='GET_HELPER_POSITION';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: PositionActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: PositionActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: PositionActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: PositionActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: PositionActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: PositionActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: PositionActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: PositionActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: PositionActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: PositionActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: PositionActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: PositionActions.GET_HELPER_POSITION,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: PositionActions.ERROR_SERVER,
      payload: error
    };
  }
}